<template>
  <v-text-field
    :label="item.text"
    maxlength="19"
    :value="displayValue"
    @blur="updateValue"
    :disabled="!editable"
    hint="Napr. 31.12.2020 16:40:00"
    clearable
  />
</template>

<script>
import moment from "moment"
//import * as Miscella from "../plugins/miscella.js"

export default {
  name: "BaseDateInput",
  props: {
    item: {
      type: Object,
      required: true
    },
    value: {
      default: null
    },
    editable: {
      type: Boolean,
      default: true
    }
  },
  components: {},
  data: function() {
    return {}
  },
  computed: {
    displayValue: function() {
      //let ret = Miscella.formatDatumACas(this.value, "DD.MM.YYYY HH:mm:ss")
      let v = moment(this.value, "YYYY-MM-DDTHH:mm:ss")
      let ret = ""
      if (v.isValid()) {
        ret = v.format("DD.MM.YYYY HH:mm:ss")
      }
      if (ret === "01.01.0001 00:00:00") {
        ret = ""
      }
      // console.log("displayValue", this.value, ret)
      return ret
    }
  },
  watch: {},
  methods: {
    updateValue: function(evt) {
      let val = evt.srcElement.value
      // console.log("updateValue 1", val)
      let v = moment(val, "DD.MM.YYYY HH:mm:ss")
      // console.log("updateValue 2", v, v.isValid())
      let ret = ""
      if (v.isValid()) {
        ret = v.format("YYYY-MM-DDTHH:mm:ss") + "Z"
      }
      // console.log("updateValue 3", ret)
      this.$emit("input", ret)
    }
  }
}
</script>
